export const REALDB_CONSTANT = {
  Sellersdata: "/Sellersdata",
  SellerBaseData: "/SellerBaseData",
};
